<div class="section">
  @if (condominium) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>Informações do condomínio</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-divider></mat-divider>
        <h4>Síndico</h4>
        <p><strong>Nome:</strong> {{ condominium.owner?.name }}</p>
        
        <mat-divider></mat-divider>
        <h4>Identificação</h4>
        <p><strong>Nome:</strong> {{ condominium.name }}</p>
        <p><strong>CNPJ:</strong> {{ condominium.cnpj || '-' }}</p>

        <mat-divider></mat-divider>
        <h4>Contatos</h4>
        <p><strong>Email:</strong> {{ condominium.email || '-' }}</p>
        <p><strong>Telefones:</strong> {{ (condominium.phoneNumbers || []).join(', ') || '-' }}</p>
        
        <mat-divider></mat-divider>
        <h4>Endereço</h4>
        <p>{{ condominium.address?.street }}, {{ condominium.address?.number }} — {{ condominium.address?.city }} / {{ condominium.address?.state }}</p>
        @if (condominium.address?.complement) {
          <p>{{ condominium.address?.complement }}</p>
        }
        @if (condominium.address?.neighborhood) {
          <p>{{ condominium.address?.neighborhood }}</p>
        }
        @if (condominium.address?.country || condominium.address?.zipCode) {
          <p>
            {{ condominium.address?.country }}
            @if (condominium.address?.zipCode) { — CEP: {{ condominium.address?.zipCode }} }
          </p>
        }
      </mat-card-content>
    </mat-card>
  }
</div>


